// extracted by mini-css-extract-plugin
export default {"slot":"Slot_slot__+NFpb"};